import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=d2650fa6&"
import script from "./Teaser.vue?vue&type=script&lang=js&"
export * from "./Teaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports